import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as wActs from "../actions/website-actions";
import URL from 'url-parse';
import * as wConsts from "../consts/website-consts";
import NotFound from "../components/notfound";
import Agency from "./agency";
import * as ReactDOM from 'react-dom';
import SwBanner from "../components/swbanner";
import BuyAdsBanner from "../components/buyadsbanner";

class Profile extends Component {


  constructor(props) {
    super(props);
    this.state = {
      showAllServices: false,
      panel: "photos",
      cpanel: "email"
    }

  }


  showAllServices(e) {
    e.preventDefault();
    this.setState({showAllServices: true});
  }
  hideAllServices(e) {
    e.preventDefault();
    this.setState({showAllServices: false});
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  getMessageNames(type) {
    switch(type) {
      case "EMAIL": { return "Email"; }
      case "SMS": { return "SMS"; }
      case "CHAT": { return "Chat"; }
      default: { return "Email"; }
    }
  }
  componentDidMount() {
    //set page for app
    //this.props.pageHandler('profile');
    let pth = wActs.stripCulturePath(this.props.location.pathname);
    //console.log("Path", pth);
    if(pth.toLowerCase().startsWith("/escort-agency-")
      || pth.toLowerCase().startsWith("/private-apartment-")
      || pth.toLowerCase().startsWith("/sex-club-")
      || pth.toLowerCase().startsWith("/erotic-massage-")
      || pth.toLowerCase().startsWith("/massage-parlor-")
      || pth.toLowerCase().startsWith("/sauna-")
      || pth.toLowerCase().startsWith("/escort-bureau-")
      || pth.toLowerCase().startsWith("/escortbureau-")
      || pth.toLowerCase().startsWith("/prive-huis-")
      || pth.toLowerCase().startsWith("/privehuis-")
      || pth.toLowerCase().startsWith("/prive-ontvangst-")
      || pth.toLowerCase().startsWith("/priveontvangst-")
      || pth.toLowerCase().startsWith("/erotische-massage-")
      || pth.toLowerCase().startsWith("/massage-salon-")
      || pth.toLowerCase().startsWith("/massagesalon-")
      || pth.toLowerCase().startsWith("/sexclub-")
      || pth.toLowerCase().startsWith("/brothel-")
      || pth.toLowerCase().startsWith("/directory-")
    ) {
      return;
    }

    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "profile" });
    let id = this.getTheId();

    if (id in this.props.profile) {
      //console.log(this.props.profile);
    } else {
      //this.props.dispatch(proActions.getProfile(id));
    }

    if (this.props.WebPage.PageLoaded) {
      let profile = this.getProfile(id);
      this.AboutMe.innerHTML = profile.Text;
    }
  }




  showCPanel(e,p) {
    e.preventDefault();
    setTimeout(() => {
      const node = ReactDOM.findDOMNode(this.Panels);
      node.scrollIntoView();
    },100);
    this.setState({cpanel: p, panel: "contact"});
  }

  showPanel(e,p) {
    e.preventDefault();
    setTimeout(() => {
      const node = ReactDOM.findDOMNode(this.Panels);
      node.scrollIntoView();
    },100);
    this.setState({panel: p});
  }

  getProfile(id) {
    let pro = this.props.profile.filter((t) => { return t.Id == id; });
    if (pro.length > 0) return pro[0];
    return null;
  }


  setMarkup() {
    let markup = "";
    let id = this.getTheId();
    let pro = this.getProfile(id);
    if (pro !== null && pro.Text) {
      markup = pro.Text;
    }
    return {__html: markup};
  }


  getTheId() {
    //console.log("p", this.props.match.params);

    let id = this.props.match.params.id;
    if(id.indexOf("-")>=0) {
      let t = id.split("-");
      id = t[t.length-1];
    }
    return id;
  }


  loader() {
    return (
    <p style={{display: "flex", alignContent: "center", justifyContent: "center" }}>
        <img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/loader.gif?v=13`} width={"100px"} height={"100px"} alt={"Loading"} />
    </p>
    );
  }

  handleReadFull() {
    if (typeof window !== "undefined") { window.HandleReadFull(); }
  }


  handleSendMessage(e) {
    e.preventDefault();
    let profile = this.getProfile(this.getTheId());
    let dta = {
      Id: profile.Id,
      From: {
        Name: this.MsgName.value, Address: this.MsgEmail.value,
      },
      Text: this.MsgBody.value,
      Type: "email"
    };
    //console.log("Gonna Send:",dta);
    this.props.dispatch(wActs.SendProfileMessage(dta));
  }

  handleHideMessage(e) {
    e.preventDefault();
    this.props.dispatch({ type: wConsts.MSG_ACTION_CLOSE, payload: false });
  }

  handleShowImages(e) {
    e.preventDefault();
    this.props.dispatch({ type: wConsts.ACTION_SHOWINGIMAGES, payload: true });
  }


  isAvail(pro,wch) {
    let meets = pro.Tags.filter(tag => tag.Flags && tag.Flags.Section && tag.Flags.Section==="Meeting" );
    if(meets.length>4) { meets = meets.slice(0,4)}
    let tag = meets.filter((t) => {return t.Id === wch});
    if(tag.length>0) {
      return true;
    }
    return false;
  }


  render() {


    let ShowAgency = false;
    let pth = wActs.stripCulturePath(this.props.location.pathname);
    if(pth.toLowerCase().startsWith("/escort-agency-")
      || pth.toLowerCase().startsWith("/private-apartment-")
      || pth.toLowerCase().startsWith("/sex-club-")
      || pth.toLowerCase().startsWith("/erotic-massage-")
      || pth.toLowerCase().startsWith("/massage-parlor-")
      || pth.toLowerCase().startsWith("/sauna-")
      || pth.toLowerCase().startsWith("/escort-bureau-")
      || pth.toLowerCase().startsWith("/escortbureau-")
      || pth.toLowerCase().startsWith("/prive-huis-")
      || pth.toLowerCase().startsWith("/privehuis-")
      || pth.toLowerCase().startsWith("/prive-ontvangst-")
      || pth.toLowerCase().startsWith("/priveontvangst-")
      || pth.toLowerCase().startsWith("/erotische-massage-")
      || pth.toLowerCase().startsWith("/massage-salon-")
      || pth.toLowerCase().startsWith("/massagesalon-")
      || pth.toLowerCase().startsWith("/sexclub-")
      || pth.toLowerCase().startsWith("/brothel-")
      || pth.toLowerCase().startsWith("/directory-")
    ) {
      ShowAgency = true;
    }

    if (this.props.WebPage.PageLoaded && this.props.WebPage.Page.Name === "404") {
      return <NotFound />;
    }

    if(ShowAgency) {
      return <Agency {...this.props}/>
    }

    let id = this.getTheId();
    if(!this.props.profile) {
      return this.loader();
    }
    let profile = null;
    if (typeof this.props.profile !== "undefined") {
      profile = this.getProfile(id);
    }
    if(profile === null) {
      return this.loader();
    }


    let nUrl = "/";
    let pUrl = "/";

    if(!wActs.isNullOrUndefined(profile.Links.Next)) {
      let N = new URL(profile.Links.Next.Url);
      nUrl = N.pathname + N.query;
    }

    if(!wActs.isNullOrUndefined(profile.Links.Previous)) {
      let P = new URL(profile.Links.Previous.Url);
      pUrl = P.pathname + P.query;
    }

    const { Languages, Tags } = profile;
    let mainImage = profile.Image;


    let Images = profile.Images.filter((t)=> {return t.Private === false});
    if(wActs.isLoggedIn(this.props.WebPage)) {
      Images = profile.Images;
    }


    //console.log(Images)


    let profileBlocked = false;
    if(profile.Blocks.some((v) => { return v === this.props.WebPage.Request.CountryCode || v === "ALL"})) {
      profileBlocked = true;
    }
    if(!profile.Visible) {
      profileBlocked = true;
    }

    let wideText = false;
    if(wActs.isNullOrUndefined(mainImage) && Images.length<=0) {
      wideText = true;
    }

    if(!wActs.isNullOrUndefined(mainImage)) {
      if(profileBlocked) {
        mainImage.Url = "/imgs/placeholder1.png";
        mainImage.MaxUrl = "/imgs/placeholder1.png";
      }
    } else {
      mainImage = {}
      mainImage.Url = "/imgs/placeholder1.png";
      mainImage.MaxUrl = "/imgs/placeholder1.png";
    }



    const mob = this.props.WebPage.ServerParams.IsMobile;
    const phn = profile.PhoneNumber;
    const phni = profile.PhoneText;
    const phns = phni.toUpperCase().indexOf("SMS")>-1;

    const hidw = !wActs.isNullOrUndefined(this.props.WebPage.Settings.ShowWebPageUrlsInProfiles) && !this.props.WebPage.Settings.ShowWebPageUrlsInProfiles;


    return (
      <React.Fragment>

        <div className="model-title-section">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="section-title">
                  <h1 style={{fontSize: "2.8rem"}}>{this.props.WebPage.Page.H1Text}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="model-bio">
          <div className="arrow-navigation">
            <div className="arrows-wrapper">
              {pUrl != "/" &&
              <Link to={pUrl} title={profile.Links.Previous.Title}>
              <span className="left-arrow">
                <i className="fa fa-angle-left" aria-hidden="true"></i>
              </span>
              </Link>
              }
              {nUrl != "/" &&
              <Link to={nUrl} title={profile.Links.Next.Title}>
              <span className="right-arrow">
                <i className="fa fa-angle-right" aria-hidden="true"></i>
              </span>
              </Link>
              }
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="escort-avatar">
                  {!profileBlocked ? <img style={{width: "100%"}} src={mainImage.Url} alt={this.props.WebPage.Page.AltText.replace("{{Number}}","1")} /> : <img style={{width: "100%"}} src={mainImage.Url + "?blur=50"} alt={this.props.WebPage.Page.AltText.replace("{{Number}}","1")} /> }
                </div>
                <div className="escort-info">
                  <div className="escort-name">
                    <span>{profile.EscortName}</span>
                  </div>

                  <div className="escort-interes escort-location">
                    <div className="box-wrapper">
                      <h3>{this.getTranslation("page.profile.location")}</h3>
                      {!wActs.isNullOrUndefined(profile.Location) &&
                      <div className="location-wrapper">
                        <span className={`flag ${profile.Location.Country ? profile.Location.Country.Code.toLowerCase() : ""}`}></span>
                        <span className="city" style={{color: "#fff"}}>{profile.Location.City.Name}</span>
                      </div>

                      }
                      {profile.Tours.map((v,i)=> {
                        <p  style={{color: "#fff"}} key={"tour-" + i}>v.Text</p>
                      })}
                    </div>
                  </div>

                  <div className="escort-interes">
                    <div className="box-wrapper">
                      <h3>{this.getTranslation("page.profile.meetingwith")}</h3>
                      <div className="interes-wrapper">

                        {this.isAvail(profile,50004) &&
                        <span className="men-search">
                        <img src="/imgs/men-icon.png" alt={this.getTranslation("page.profile.men")}/>
                        <p>{this.getTranslation("page.profile.men")}</p>
                      </span>
                        }
                        {this.isAvail(profile,50005) &&
                        <span className="women-search">
                        <img src="/imgs/women-icon.png" alt={this.getTranslation("page.profile.women")}/>
                        <p>{this.getTranslation("page.profile.women")}</p>
                      </span>
                        }
                        {this.isAvail(profile,50006) &&
                        <span className="trans-search">
                        <img src="/imgs/trans-icon.png" alt={this.getTranslation("page.profile.couples")}/>
                        <p>{this.getTranslation("page.profile.couples")}</p>
                      </span>
                        }
                        {this.isAvail(profile,50096) &&
                        <span className="men-search">
                        <img src="/imgs/men-icon.png" alt={this.getTranslation("page.profile.gays")}/>
                        <p>{this.getTranslation("page.profile.gays")}</p>
                      </span>
                        }
                        {this.isAvail(profile,50103) &&
                        <span className="trans-search">
                        <img src="/imgs/trans-icon.png" alt={this.getTranslation("page.profile.trans")}/>
                        <p>{this.getTranslation("page.profile.trans")}</p>
                      </span>
                        }
                      </div>
                    </div>
                  </div>


                  {this.props.WebPage.ServerParams.IsMobile &&
                  <div className="escort-interes escort-location">
                    <div className="box-wrapper">
                      <h3>{this.getTranslation("page.profile.phone")}</h3>
                      <h4 style={{marginBottom: "-5px"}}>{phn}</h4>
                      <h5>{phni}</h5>
                    </div>
                  </div>
                  }

                  <div className="escort-interes escort-location">
                    <div className="box-wrapper">
                      <h3>{this.getTranslation("page.profile.contact")}</h3>
                      <div className="model-contact-icons">
                        <ul>
                          {!wActs.isNullOrEmpty(phn) &&

                          <li>
                            {mob &&
                            <a href={"tel://" + phn.replace('+', '').replace(' ', '')} onClick={(e) => {this.showCPanel(e,"phone")}} className="cmodel-link" title={this.getTranslation("page.profile.callme")}><span className="img-wrapper"><img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/call-icon.png`} alt={this.getTranslation("page.profile.callme")}/></span><p style={{color: "#fff"}}>{this.getTranslation("page.profile.callme")}</p></a>
                            }
                            {!mob &&
                            <a href="#none" onClick={(e) => {this.showCPanel(e,"phone")}} className="cmodel-link" title={this.getTranslation("page.profile.callme")}><span className="img-wrapper"><img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/call-icon.png`} alt={this.getTranslation("page.profile.callme")}/></span><p style={{color: "#fff"}}>{this.getTranslation("page.profile.callme")}</p></a>
                            }
                          </li>
                          }
                          {profile.HasWhatsApp &&
                          <li>
                            <a href={"https://api.whatsapp.com/send?phone=" + profile.WhatsAppPhoneNumber.replace('+', '').replace(' ', '')} className="cmodel-link" title="WhatsApp" target="_blank"><span className="img-wrapper"><img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/whatsapp-icon.png`} alt="WhatsApp"/></span><p style={{color: "#fff"}}>WhatsApp</p></a>
                          </li>
                          }
                          {profile.HasViber &&
                          <li>
                            <a href={"viber://chat?number=" + profile.ViberPhoneNumber.replace('+', '').replace(' ', '')} className="cmodel-link" title="Telegram"><span className="img-wrapper"><img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/viber-icon.png`} alt="Viber"/></span><p style={{color: "#fff"}}>Viber</p></a>
                          </li>
                          }
                          {profile.HasTelegram &&
                          <li>
                            <a href={"https://t.me/" + profile.TelegramPhoneNumber.replace('+', '').replace(' ', '')} className="cmodel-link" title="Telegram"><span className="img-wrapper"><img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/telegram-icon.png`} alt="Telegram"/></span><p style={{color: "#fff"}}>Telegram</p></a>
                          </li>
                          }

                          {profile.HasSkype &&
                          <li>
                            <a href={"skype://" + profile.Skype + "?chat"} className="cmodel-link" title="Telegram"><span className="img-wrapper"><img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/skype.png`} alt="Skype"/></span><p style={{color: "#fff"}}>Skype</p></a>
                          </li>
                          }
                          {!wActs.isNullOrEmpty(profile.EmailAddress) &&
                            <li>
                              <a href="#none" onClick={(e) => {this.showCPanel(e,"email")}}  className="cmodel-link" title={this.getTranslation("page.profile.callme")}><span className="img-wrapper"><img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/email-icon.png`} alt={this.getTranslation("page.profile.sendemail")}/></span><p style={{color: "#fff"}}>{this.getTranslation("page.profile.sendemail")}</p></a>
                            </li>
                          }
                          {phns &&
                          <li>
                          {mob &&
                            <a href={"sms://" + phn.replace('+', '').replace(' ', '')} onClick={(e) => {this.showCPanel(e,"phone")}} className="cmodel-link" title="Messenger"><span className="img-wrapper"><img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/sms-icon.png`} alt={this.getTranslation("page.profile.sendsms")}/></span><p style={{color: "#fff"}}>{this.getTranslation("page.profile.sendsms")}</p></a>
                            }
                            {!mob &&
                            <a href="#none" onClick={(e) => {this.showCPanel(e,"phone")}} className="cmodel-link" title="Messenger"><span className="img-wrapper"><img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/sms-icon.png`} alt={this.getTranslation("page.profile.sendsms")}/></span><p style={{color: "#fff"}}>{this.getTranslation("page.profile.sendsms")}</p></a>
                            }
                          </li>
                          }
                          {(!wActs.isNullOrEmpty(profile.WebPageUrl) && !hidw) &&
                          <li>
                            <a href={profile.WebPageUrl} target="_blank" className="cmodel-link" title="Website"><span className="img-wrapper"><img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/website-icon.png`} alt={this.getTranslation("page.profile.visitwebsite")}/></span><p style={{color: "#fff"}}>{this.getTranslation("page.profile.visitwebsite")}</p></a>
                          </li>
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-8">

                <div className="escort-info">
                  <div className="escort-measurements">
                    <ul>
                      {!wActs.isNullOrUndefined(profile.Height) && profile.Height > 0  &&
                      <li>
                        <span>{this.getTranslation("page.profile.height")}</span>
                        <span>{profile.Height}</span>
                      </li>
                      }
                      {!wActs.isNullOrEmpty(profile.Tits) &&
                      <li>
                        <span>{this.getTranslation("page.profile.tits")}</span>
                        <span>{profile.Tits}</span>
                      </li>
                      }

                      {!wActs.isNullOrUndefined(profile.Age) && profile.Age > 0 &&
                      <li>
                        <span>{this.getTranslation("page.profile.age")}</span>
                        <span>{profile.Age}</span>
                      </li>
                      }
                      {!wActs.isNullOrEmpty(profile.Nationality) &&
                      <li>
                        <span>{this.getTranslation("page.profile.nationality")}</span>
                        <span>{profile.Nationality}</span>
                      </li>
                      }
                      <li>
                        <span>{this.getTranslation("page.profile.gender")}</span>
                        <span>{profile.Sex}</span>
                      </li>
                    </ul>
                  </div>
                </div>



                <article className="escrot-bio">
                  {this.props.WebPage.Settings.ShowSlogan &&
                  <h2>{profile.Slogan}</h2>
                  }
                  <p ref={(ref) => {this.AboutMe = ref}} dangerouslySetInnerHTML={this.setMarkup()}></p>
                </article>


                <div className={"wide-banner"} style={{margin: "30px auto", display: "flex", justifyContent: "center", maxWidth: "100%", overflow: "hidden"}}>
                  <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-728x90-leaderboard']}  className="partners-list" >
                    <BuyAdsBanner size="728x90" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                  </SwBanner>
                </div>

                <div className="modelBio-toggle">
                  <a style={{cursor: "pointer"}} className={`model-btn ${this.state.panel === "photos" ? "active" : ""}`} onClick={(e) => {this.showPanel(e,"photos")}}>Photos</a>
                  <a style={{cursor: "pointer"}} className={`model-btn ${this.state.panel === "services" ? "active" : ""}`} onClick={(e) => {this.showPanel(e,"services")}}>{this.getTranslation("page.profile.services")}</a>
                  <a style={{cursor: "pointer"}} className={`model-btn ${this.state.panel === "contact" ? "active" : ""}`} onClick={(e) => {this.showPanel(e,"contact")}}>{this.getTranslation("page.profile.contact")}</a>
                </div>

                <div className={"model-toggle-wrapper " + (this.state.panel === "photos" ? "model_photos" : "model_services") }>
                  <div className="escort-gallery">
                    <div className="thumb-imgs">
                      {Images.map((img, i) => {
                        if(!wActs.isLoggedIn(this.props.WebPage)) {
                          if(i>5) return;
                        }

                        let cName = "";
                        let imgStyle={width: "91px", height: '66px', overflow: "hidden"};
                        if((i === Images.length - 1 || i === 5)) {
                          imgStyle={width: "91px", height: '66px', overflow: "hidden", position: 'relative'};
                          cName = "blackenHref";
                        }
                        let thm = img.Url;
                        let src = img.MaxUrl;
                        if(profileBlocked) {
                          thm = "/imgs/placeholder3.png"
                          src = "/imgs/placeholder1.png"
                        }
                        return (
                          <a onClick={(e) => {this.handleShowImages(e)}} href={src} key={img.ImageId} style={imgStyle} className={cName} data-fancybox="escort-gallery">
                            <img style={{width: "150px"}} src={thm} alt={this.props.WebPage.Page.AltText.replace("{{Number}}", (i + 2))}/>
                          </a>
                        );
                      })}
                    </div>
                  </div>
                  <div className="escort-services" style={{display: this.state.panel === "services" ? "block" : "none"}}>
                    <ul>
                      {profile.Tags.map((v,i) => {
                        if(i>7 && !this.state.showAllServices) {return null;}
                        return <li key={"tag-" + i}>{v.Name}</li>
                      })}
                      {!this.state.showAllServices && profile.Tags.length>7 &&
                        <li key = "tag-more"><a href="#none" onClick={(e) => {this.showAllServices(e)}}>Show all</a></li>
                      }
                      {this.state.showAllServices && profile.Tags.length>7 &&
                        <li key = "tag-more"><a href="#none" onClick={(e) => {this.hideAllServices(e)}}>Hide</a></li>
                      }

                    </ul>
                  </div>
                </div>

                <section ref={(ref) => {this.Panels = ref}} className="contact-model"  style={{display: this.state.panel === "contact" ? "block" : "none"}}>
                  <div className="container">
                    <div className="row">
                      <div className="col">
                        <div className="contact-wrapper">
                          <div className="right-panel">
                            <div className="left-panel">
                              <h3>{this.getTranslation("page.profile.contactinfo")}</h3>
                              <div className="model-contact"></div>
                            </div>
                            <div style={{display: this.state.cpanel === "phone" ?  "block" : "none"}}>
                              <h3>{this.getTranslation("page.profile.phone")}</h3>
                              <h4 style={{marginBottom: "-5px"}}>{phn}</h4>
                              <h5>{phni}</h5>
                            </div>
                            <div style={{display: this.state.cpanel === "email" ?  "block" : "none"}}>
                            <h3>{this.getTranslation("page.sendmessage")}</h3>
                            <form action="">
                              <div className="form-row">
                                <div className="input-field">
                                  <span>{this.getTranslation("page.yourname")}</span>
                                  <input type="text" ref={(ref) => {this.MsgName = ref}}/>
                                </div>
                                <div className="input-field">
                                  <span>{this.getTranslation("page.email")}</span>
                                  <input type="text" ref={(ref) => {this.MsgEmail = ref}}/>
                                </div>
                              </div>
                              <div className="form-row">
                                <div className="textarea-wrapper">
                                  <textarea name="" id="" cols="30" rows="10" placeholder={this.getTranslation("page.writeyourmessagehere")} style={{resize: "none"}} ref={(ref) => {this.MsgBody = ref}}></textarea>
                                </div>
                              </div>
                              <div className="form-btns">
                                <div className="msg-sent">
                                  <input type="submit" value={this.getTranslation("page.submit")} onClick={(e) => {this.handleSendMessage(e)}}/>
                                </div>
                              </div>
                              <div className="selected-files">

                              </div>
                            </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>



              </div>
            </div>
          </div>
        </section>



      </React.Fragment>
    );
  }


}

const mapStateToProps = (state, ownProps) => {
  return {
    profile: state.Profiles.Cache,
    WebPage: state.Website
  };
};

export default connect(mapStateToProps)(Profile);
